function openInfluencerModal(element) {
    const title = element.getAttribute('data-title');
    const price = element.getAttribute('data-price');
    const videoSrc = element.getAttribute('data-video');
    const imageSrc = element.getAttribute('data-image');
    const variantId = element.getAttribute('data-variant-id');
    const productUrl = element.getAttribute('data-url');

    document.getElementById('modal-product-title').textContent = title;
    document.getElementById('modal-product-price').textContent = price;
    document.getElementById('modal-video').src = videoSrc;
    document.getElementById('modal-product-image').src = imageSrc;
    document.getElementById('modal-product-url').href = productUrl;

    // Set the variant ID in the product form
    // document.querySelector('#modal-product-form .product-variant-id').value = variantId;

    document.getElementById('ap-influencer-section__modal-wrapper').style.display = 'flex';
    document.body.classList.add('modal-open');
  }

  function influencer_modalClose() {
    document.getElementById('ap-influencer-section__modal-wrapper').style.display = 'none';
    document.body.classList.remove('modal-open');
  }